import Tab from '@mui/material/Tab';
import MUITabs from '@mui/material/Tabs';
import { useLocation, useNavigate } from 'react-router';
import { DEAL_INSIGHTS_PATH, TABS } from '../../../constants.ts';
import { getLastPathSegment, getTabIndexFromPath, getTabPathFromIndex } from '../../../utils/tabUtils.tsx';

export const DealInsightsTabs = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const currentPath = getLastPathSegment(location.pathname);
  const tabIndex = getTabIndexFromPath(currentPath);

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    const tabPath = getTabPathFromIndex(newValue);
    navigate(tabPath ? `${DEAL_INSIGHTS_PATH}/${tabPath}` : DEAL_INSIGHTS_PATH);
  };

  return (
    <MUITabs
      value={tabIndex}
      onChange={handleTabChange}
      sx={{ backgroundColor: 'transparent', borderBottom: 'transparent', flexShrink: 0 }}
    >
      {TABS.map(tab => (
        <Tab key={tab.name} label={tab.name} />
      ))}
    </MUITabs>
  );
};
